import type {
  ApiError,
  WorkspaceAdminState,
  WorkspaceAdminSummary,
  WorkspaceSummaryResponse,
} from '@/shared/api';

export const ADMIN_STATE_LABEL: Record<WorkspaceAdminState, string> = {
  Pending: 'Ausstehend',
  Active: 'Aktiv',
};

export function adminDisplayName(admin: WorkspaceAdminSummary): string {
  const name = [admin.firstName, admin.lastName].filter(Boolean).join(' ').trim();
  return name || admin.email || 'Ohne Namen';
}

/**
 * Nur dort, wo der Server die Einladung annimmt: ausstehend, Kunden-Workspace, nicht gesperrt.
 * Ein gesperrter Workspace verschickt keine Mails; der Knopf wäre ein Versprechen ohne Wirkung.
 */
export function canResendInvitation(
  workspace: WorkspaceSummaryResponse,
  admin: WorkspaceAdminSummary,
): boolean {
  return admin.state === 'Pending' && workspace.kind === 'Customer' && workspace.isActive;
}

const RESEND_FAILURE: Record<string, string> = {
  'Workspace.AdminAlreadyActive':
    'Die Einladung ist bereits angenommen — der Administrator ist aktiv.',
  'Workspace.AdminNotFound':
    'Diesen ausstehenden Administrator gibt es in diesem Workspace nicht mehr.',
  'Workspace.NotFound': 'Diesen Kunden-Workspace gibt es nicht mehr.',
  'Workspace.InvitationRequiresActiveWorkspace':
    'Der Workspace ist gesperrt. Erst nach der Freigabe lässt sich erneut einladen.',
  'User.InvitationChanged': 'Das Konto wurde gerade geändert. Bitte die Liste neu laden.',
};

/** Der Grund des Servers als Satz; ein unbekannter Code bleibt als „Fehler <code>" sichtbar. */
export function resendFailureText(error: ApiError): string {
  if (error.status === 0) {
    return 'Keine Antwort vom Server — ob die Einladung verschickt wurde, ist offen. Bitte die Liste neu laden.';
  }
  if (error.status === 403) {
    return 'Dafür fehlt die Berechtigung als Plattform-Administrator.';
  }
  return RESEND_FAILURE[error.title] ?? error.detail ?? `Fehler ${error.title}`;
}
